<template>
  <div>
    <div
      class="text-center error--text pa-2 mb-2 fs-14px font-weight-medium"
      v-if="request.type == 3"
    >
      THU HỒI
    </div>
    <div
      class="text-center purple--text pa-2 mb-2 fs-14px font-weight-medium"
      v-else
    >
      Lấy về
    </div>

    <div>
      <v-row dense>
        <v-col cols="12">
          <input-qr-scan-model
            v-model="code"
            ref="codeRef"
            label="Quét mã tài sàn"
            @keyupEnter="scanInput"
          ></input-qr-scan-model>
        </v-col>

        <v-col cols="12">
          <v-simple-table class="table-padding-2 table-h-36">
            <template v-slot:default>
              <thead class="v-data-table-header">
                <tr>
                  <th
                    role="columnheader"
                    class="text-center"
                    style="width: 45px; min-width: 45px"
                  >
                    Mã
                  </th>
                  <th
                    role="columnheader"
                    class="text-center"
                    style="width: 75px"
                  >
                    Loại tài sản
                  </th>
                  <th role="columnheader" class="text-center">Tài sản</th>
                  <th
                    role="columnheader"
                    class="text-center"
                    style="width: 45px; min-width: 45px"
                  >
                    Đã trả
                  </th>
                  <th
                    role="columnheader"
                    class="text-center"
                    style="width: 45px; min-width: 45px"
                  >
                    Hư hại
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in items"
                  :key="`i_${index}_${item.id}`"
                  class="text-center"
                >
                  <td style="width: 45px; min-width: 45px">
                    {{ item.name }}
                  </td>
                  <td>
                    {{ item.asset_type_name }}
                  </td>
                  <td>
                    {{ item.asset_name }}
                  </td>
                  <td style="width: 45px; min-width: 45px">
                    <span
                      :class="item.is_scanned ? 'success--text' : 'error--text'"
                    >
                      {{ item.is_scanned }}
                    </span>
                    /
                    <span class="font-weight-medium">1</span>
                  </td>
                  <td style="width: 45px; min-width: 45px">
                    <div class="d-flex align-center justify-center">
                      <v-checkbox
                        v-if="item.is_scanned"
                        v-model="item.is_damage"
                        class="mt-0 ml-1"
                        :value="1"
                        hide-details
                      ></v-checkbox>
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>

      <v-divider class="mb-3"></v-divider>

      <OrderDetail :order="order" :is-show-item="false" />

      <v-row no-gutters class="fs-12">
        <v-col cols="4" class="text-right font-weight-medium black--text">
          Cơ sở nhận: &nbsp;
        </v-col>
        <v-col cols="8">
          <span class="text-capitalize purple--text font-weight-medium">
            {{ request.branch_code }}
          </span>
        </v-col>
      </v-row>

      <v-btn color="primary" block class="mt-3" @click="showDialogConfirm">
        {{ request.type == 3 ? "Đã thu hồi" : "Đã lấy" }}
      </v-btn>
    </div>

    <v-dialog v-model="confirmDialog" max-width="420px">
      <v-card>
        <v-card-title class="text-h6" style="padding: 10px 10px 10px">
          {{ $t("Phát sinh") }}
        </v-card-title>

        <v-card-text style="padding: 10px">
          <v-simple-table
            class="table-padding-2 table-h-36"
            v-if="indemnifyItems.length > 0 || order.overdue_amount > 0"
          >
            <template v-slot:default>
              <thead class="v-data-table-header">
                <tr>
                  <th role="columnheader" class="text-center">Tài sản</th>
                  <th role="columnheader" class="text-center">Phân loại</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="text-center"
                  v-for="item in indemnifyItems"
                  :key="`idm_${item.id}`"
                >
                  <td>{{ item.name }} - {{ item.asset_type_name }}</td>
                  <td style="width: 60px; min-width: 60px">
                    {{ !item.is_scanned ? "Mất" : "Hư hại" }}
                  </td>
                </tr>
                <tr class="text-center purple--text">
                  <td style="width: 60px; min-width: 60px">
                    {{ $t("Quá hạn") }}
                  </td>
                  <td>
                    {{ order.overdue_hour }} giờ -
                    {{ formatNumber(order.overdue_amount) }}đ
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <v-file-input
                      label="Hình ảnh tài sản"
                      placeholder="Hình ảnh tài sản"
                      v-model="file"
                      append-icon="mdi-paperclip"
                      prepend-icon=""
                      dense
                      outlined
                      hide-details
                      multiple
                      class="c-input-small"
                      accept="image/*"
                      @change="onInputFileChange"
                    ></v-file-input>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <div v-else>
            Đơn hàng không có phát sinh. <br />
            Bấm xác nhận để hoàn thành!
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="hideDialogConfirm">
            {{ $t("Đóng") }}
          </v-btn>
          <v-btn color="green darken-1" text @click="updateToProcessed">
            {{ $t("Xác nhận") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { compress } from "image-conversion";
import { httpClient } from "@/libs/http";
import moment from "moment";

export default {
  name: "ReturnProcessing",
  components: {
    OrderDetail: () => import("@/components/common/OrderDetail"),
  },
  props: {
    order: {
      type: Object,
      default: () => {},
    },
    request: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    code: null,
    items: [],
    confirmDialog: false,
    file: null,
    images: [],
  }),
  computed: {
    scannedCodes() {
      return [...this.items]
        .filter((item) => item.is_scanned)
        .map((item) => item.code);
    },
    noScanCodes() {
      return [...this.items]
        .filter((item) => !item.is_scanned)
        .map((item) => item.code);
    },
    indemnifyItems() {
      return [...this.items].filter(
        (item) => item.is_damage || !item.is_scanned
      );
    },
  },
  mounted() {
    this.items = [...this.order.items].map((item) => ({
      ...item,
      is_scanned: 0,
      is_damage: 0,
    }));
  },
  methods: {
    confirmed() {
      this.$emit("confirmed");
    },
    finished() {
      this.$emit("finished");
    },
    showDialogConfirm() {
      this.confirmDialog = true;
    },
    hideDialogConfirm() {
      this.confirmDialog = false;
    },
    async onInputFileChange(files) {
      if (this.isLoading) {
        this.$vToastify.warning(this.$t("messages.loading"));
        return false;
      }

      this.isLoading = true;

      const images = [];
      for (let i = 0; i < files.length; i++) {
        const url = await this.uploadFile(files[i]);
        images.push(url);
      }

      this.isLoading = false;

      this.images = [...images];
    },

    async uploadFile(file) {
      const resBlob = await compress(file, {
        quality: 0.85,
        width: 1024,
        type: "image/jpeg",
      });
      const newFile = new File(
        [resBlob],
        `${moment().unix()}_${this.generateRandomString(10)}.jpg`,
        { type: "image/jpeg" }
      );
      let fd = new FormData();
      fd.append("file", newFile);
      const { data } = await httpClient.post(`/common/v1/upload-image`, fd);
      return data;
    },
    scanInput() {
      if (!this.code) {
        return false;
      }

      const code = this.code.toUpperCase();

      if (this.scannedCodes.includes(code)) {
        this.code = null;
        document.getElementById("error_sound_player").play();
        this.$vToastify.error(this.$t("Mã đã quét"));
        return false;
      }

      if (!this.noScanCodes.includes(code)) {
        this.code = null;
        document.getElementById("error_sound_player").play();
        this.$vToastify.error(this.$t("Mã không đúng"));
        return false;
      }

      if (this.isLoading) {
        this.$vToastify.warning(this.$t("Loading"));
        return false;
      }

      this.isLoading = true;

      const items = [...this.items];
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.code == code) {
          item.is_scanned = 1;
        }
        items[i] = { ...item };
      }

      this.items = [...items];
      this.code = null;
      this.isLoading = false;
      document.getElementById("success_sound_player").play();
    },
    async updateToProcessed() {
      if (this.isLoading) {
        this.$vToastify.warning(this.$t("Loading"));
        return false;
      }

      this.isLoading = true;

      try {
        await httpClient.post("/order/v1/delivery-return-processed", {
          items: this.items,
          images: this.images,
          id_request: this.request.id,
        });
        this.isLoading = false;
        document.getElementById("success_sound_player").play();
        this.hideDialogConfirm();
        this.finished();
      } catch (e) {
        const errMsg =
          (e.response &&
            e.response.data &&
            e.response.data.error &&
            e.response.data.error.message) ||
          null;
        this.$vToastify.error(errMsg);
        this.code = null;
        this.isLoading = false;
        document.getElementById("error_sound_player").play();
      }
    },
  },
};
</script>
